module Bookhus.Widgets {
    export class EventcalendarDescriptions {
        private culture: string;
        private houseId: number;
        private containerId: string;
        private events: IBooking[];

        constructor(culture: string, containerId: string, houseId: number) {
            this.culture = culture;
            this.containerId = containerId;
            this.houseId = houseId;
        }

        public reload(startdate: Date, enddate: Date) {
            // genindlæs data
            var xhr = this.loadDataAjax(this.houseId, startdate, enddate);
            xhr.always((jqxhr, textStatus, error) => {
                this.drawEventdescriptionlist();
            });
        }

        public loadEventDescriptionList(startdate: Date, enddate: Date): Promise<string> {
            return new Promise((resolve, reject) => {
                // genindlæs data
                var xhr = this.loadDataAjax(this.houseId, startdate, enddate);
                xhr.always((jqxhr, textStatus, error) => {
                    var eventDescriptionListHtml = this.buildEventDescriptionList();
                    if (!eventDescriptionListHtml) {
                        reject();
                        return;
                    }
                    resolve(eventDescriptionListHtml);
                });
            });
        }

        public displayPopup(startDate: Date, endDate?: Date): Promise<void> {
            return new Promise((resolve, reject) => {

                if (!endDate) {
                    endDate = startDate;
                }

                var xhr = this.loadDataAjax(this.houseId, startDate, endDate);
                xhr.always((jqxhr, textStatus, error) => {

                    var eventDescriptionListHtml = this.buildEventDescriptionList();
                    if (!eventDescriptionListHtml) {
                        resolve();
                        return;
                    }

                    swalModal.fire({
                        title: (window as any).Bookhus.Localization.Standard.UI.GeneralText.KindlyNote,
                        html: eventDescriptionListHtml
                    }).then((result) => {
                        if (result.isConfirmed) {
                            resolve();
                        }
                    });
                });
            });
        }

        private buildEventDescriptionList(): string {
            if (!this.events || this.events.length == 0) {
                return '';
            }

            var eventdescriptionHtml = `<h4 class="mb-1 font-weight-bold">${(window as any).Bookhus.Localization.Standard.UI.Widgets.EventCalendar.EventsInPeriod}</h4>`;

            this.events.forEach(e => {
                var eventName = (e.eventName || '').trim();
                var eventDescription = (e.periodDescription || '').trim();
                var displayName = this.htmlEncode(eventName || eventDescription);
                var eventDescriptionHtml = eventName && eventDescription && eventName !== eventDescription
                    ? `<div class="row mb-1">
                           <div class="col-md-12">
                               ${this.htmlEncode(eventDescription)}
                           </div>
                       </div>`
                    : '';
                var arrivaldate = new Date(e.arrivaldateRfc1123);
                var arrivaltime = arrivaldate.toString("HH:mm");

                var departuredate = new Date(e.departuredateRfc1123);
                var departuretime = departuredate.toString("HH:mm");

                eventdescriptionHtml += `
                    <div class="row" data-eventid="${e.id}">
                        <div class="col-md-12 text-primary">
                            ${displayName}
                        </div>
                    </div>
                    ${eventDescriptionHtml}
                    <div class="row pb-3">
                        <div class="col-md-12 text-secondary" style="font-size: 12px">
                            <span class="pb-1">${$.datepicker.regional[this.culture].dayNames[arrivaldate.getDay()]}</span>
                            <span class="pb-1"><i class="mr-1"></i> ${arrivaldate.formatDate($.datepicker.regional[this.culture].dateFormat)}</span>

                            -

                            <span class="pb-1">${$.datepicker.regional[this.culture].dayNames[departuredate.getDay()]}</span>
                            <span class="pb-1"><i class="mr-1"></i> ${departuredate.formatDate($.datepicker.regional[this.culture].dateFormat)}</span>
                        </div>
                    </div>                            
                `;
            });

            return eventdescriptionHtml;
        }

        private htmlEncode(value: string): string {
            var element = document.createElement('div');
            element.textContent = value;
            return element.innerHTML;
        }

        private drawEventdescriptionlist() {
            var eventDescriptionListHtml = this.buildEventDescriptionList();
            if (!eventDescriptionListHtml) {
                // hvis der ikke er nogen skriver vi ikke noget..
                return;
            }

            $("#" + this.containerId).html(eventDescriptionListHtml);
        }

        loadDataAjax(houseId: number, startdate: Date, enddate: Date): JQueryXHR {
            var self = this;
            var xhr = $.getJSON('/api/calendar?houseId=' + houseId + '&startdate=' + startdate.formatDate("yy-mm-dd") + '&enddate=' + enddate.formatDate("yy-mm-dd") + '&type=1', function (bookings: IBooking[]) {
                self.events = bookings;
                self.houseId = houseId;
            });
            xhr.fail(function () {
                self.events = [];
                self.houseId = houseId;
            });
            return xhr;
        }
    }
}
